const routePaths = {
    DASHBOARD: "/",
    INTERNAL_FAIR_STUDENTS: "/internal/fair-students",
    NOT_FOUND: "/404",
    NOT_AUTHORIZED: "/403",
    UNIVERSITY_LOGIN: "/university_login",
    REDIRECTION: "/redirecting",
};

export default routePaths;
